import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import Input from 'core/react/general/form/Input';
import { selectedLeasesIdSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IEmailProps {
  entryPass: ITepEntryPass;
}

export const Email: FC<IEmailProps> = ({ entryPass }) => {
  const id = useSelector(selectedLeasesIdSelector);

  const { formState, control } = useFormContext<{ device: ITepEntryPass }>();

  const { errors } = formState;

  const isSelected = entryPass?.id === id;
  const error = errors.device?.lease?.email?.message;

  return isSelected ? (
    <Controller
      control={control}
      name={'device.lease.email'}
      rules={{ required: fc('please enter email') }}
      render={({ value, onChange }) => (
        <div className={styles.input}>
          <Input placeholder="enter email address" value={value} onChange={onChange} />
          {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div>{entryPass.lease?.email || '-'}</div>
  );
};
